import { cx } from '@linaria/core';
import { TransitionGroup } from 'react-transition-group';
import { breakpoints } from '@ui/css';
import { AlertIcon, PauseIcon, PlayIcon } from '@ui/kit/icons';
import { describeArcPath } from '@utils/common';
import { useMatchBreakpoint, PostloadedImage, CSSRefTransition } from '@utils/react';
import { wrapper, imageWrapper, icon, crossFadeDurationMs, asyncProgressCircle, button, modifiers } from './atom.left-graphic.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function LeftGraphic(props) {
  const isMobile = useMatchBreakpoint(breakpoints.mobile);
  const onClick = () => {
    if (props.audio.isLoading || props.audio.isPlaying) {
      props.audio.pause();
    } else {
      props.audio.resume();
    }
  };
  const progress = (props.audio.timeElapsedMs ?? 0) / (props.audio.durationMs ?? 1);
  const disabled = props.disabled || props.audio.didError;
  const withImage = !!props.imageSrc && !props.audio.didError;
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    "data-disabled": disabled,
    "data-error": props.audio.didError,
    "data-with-image": withImage,
    children: [withImage && /*#__PURE__*/jsx("div", {
      className: imageWrapper,
      children: /*#__PURE__*/jsx(PostloadedImage, {
        src: props.imageSrc,
        alt: "",
        sizes: "150px"
      })
    }), /*#__PURE__*/jsx("button", {
      className: cx(button, props.audio.isPlaying && modifiers.isPlaying.className),
      tabIndex: -1,
      "aria-hidden": true,
      onClick: onClick,
      disabled: disabled,
      children: /*#__PURE__*/jsxs(TransitionGroup, {
        component: null,
        children: [/*#__PURE__*/jsx(CSSRefTransition, {
          timeout: crossFadeDurationMs,
          classNames: icon,
          children: ref => /*#__PURE__*/jsx("div", {
            ref: ref,
            className: icon,
            children: props.audio.didError ? /*#__PURE__*/jsx(AlertIcon, {
              "data-type": "alert",
              width: isMobile ? 24 : 38
            }) : props.audio.isPlaying ? /*#__PURE__*/jsx(PauseIcon, {
              "data-type": "pause",
              width: isMobile ? 14 : 20
            }) : /*#__PURE__*/jsx(PlayIcon, {
              "data-type": "play",
              width: isMobile ? 22 : 32
            })
          })
        }, `icon-${props.audio.isPlaying}-${disabled}`), props.audio.isPlaying && /*#__PURE__*/jsx(CSSRefTransition, {
          timeout: crossFadeDurationMs,
          classNames: asyncProgressCircle,
          children: ref => /*#__PURE__*/jsx("svg", {
            ref: ref,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: isMobile ? `0 0 52 52` : `0 0 84 84`,
            className: asyncProgressCircle,
            children: /*#__PURE__*/jsx("path", {
              d: describeArcPath(isMobile ? 52 : 84, isMobile ? 2 : 4, Math.min(359.99, Math.round(progress * 360)))
            }, "progress")
          })
        })]
      })
    })]
  });
}

export { LeftGraphic };
//# sourceMappingURL=atom.left-graphic.js.map
